export default "__VITE_ASSET__287be99b__"